import { useState } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";
import { PRIVACY_POLICY, TERMS_OF_SERVICE } from "@/content/customerLegal";

function LegalPanel({ title, content, open, onToggle, checked, onChange, testId }) {
  return (
    <div className="border border-white/10 rounded-xl overflow-hidden bg-white/[0.02]">
      <button
        type="button"
        onClick={onToggle}
        className="w-full flex items-center justify-between px-4 py-3 text-left text-sm text-white/80 hover:bg-white/[0.03]"
      >
        <span>{title}</span>
        {open ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
      </button>
      {open ? (
        <div className="max-h-40 overflow-y-auto px-4 pb-3 text-[11px] leading-relaxed text-white/55 whitespace-pre-line border-t border-white/5">
          {content}
        </div>
      ) : null}
      <label className="flex items-start gap-2 px-4 py-3 border-t border-white/5 cursor-pointer">
        <input
          type="checkbox"
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
          data-testid={testId}
          className="mt-0.5 accent-[#0055FF]"
          required
        />
        <span className="text-xs text-white/70">
          {title} 내용을 확인하였으며, 이에 동의합니다. <span className="text-red-400">(필수)</span>
        </span>
      </label>
    </div>
  );
}

export default function SignupLegalAgreement({ agreedTerms, agreedPrivacy, onChangeTerms, onChangePrivacy }) {
  const [openTerms, setOpenTerms] = useState(false);
  const [openPrivacy, setOpenPrivacy] = useState(false);

  return (
    <div className="space-y-3 pt-2">
      <p className="text-[10px] uppercase tracking-[0.2em] text-white/40">약관 동의</p>
      <LegalPanel
        title="이용약관"
        content={TERMS_OF_SERVICE}
        open={openTerms}
        onToggle={() => setOpenTerms((v) => !v)}
        checked={agreedTerms}
        onChange={onChangeTerms}
        testId="signup-agree-terms"
      />
      <LegalPanel
        title="개인정보 처리방침"
        content={PRIVACY_POLICY}
        open={openPrivacy}
        onToggle={() => setOpenPrivacy((v) => !v)}
        checked={agreedPrivacy}
        onChange={onChangePrivacy}
        testId="signup-agree-privacy"
      />
    </div>
  );
}
